export default __webpack_public_path__ + "images/banner.7dc08d3016e6b8362411.png";